import { cn } from "@/zapi-frontend/shared/lib/utils";

export type TChatEngine = "ai" | "leo";

const OPTIONS: { value: TChatEngine; label: string }[] = [
  { value: "ai", label: "AI" },
  { value: "leo", label: "Leo" }
];

type TChatEngineSwitchProps = {
  value: TChatEngine;
  onChange: (value: TChatEngine) => void;
};

// Stage 2 research switch between the legacy chat pipeline and the Leo one.
export function ChatEngineSwitch({ value, onChange }: TChatEngineSwitchProps) {
  return (
    <div
      className="flex items-center gap-0.5 rounded-lg border border-innoveraZinc-150 p-0.5"
      data-testid="chat-engine-switch"
    >
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={cn(
            "rounded-md px-2 py-1 text-[11px] leading-4 transition-colors",
            value === option.value
              ? "bg-innoveraZinc-900 text-white"
              : "text-innoveraZinc-500 hover:text-innoveraZinc-900"
          )}
          data-testid={`chat-engine-${option.value}`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
